import React from 'react';
import { Link } from 'react-router-dom';
import { useDraggable } from '@dnd-kit/core';

const Card = ({ pickup }) => {
  const { attributes, listeners, setNodeRef, transform, isDragging } =
    useDraggable({
      id: `pickup-${pickup.id}`,

      data: {
        pickup,
      },
    });

  return (
    <Link
      to={`/pickups/${pickup.id}`}
      className="text-decoration-none"
      style={{
        color: 'inherit',
        
      }}
    >
      <div
        ref={setNodeRef}
        {...listeners}
        {...attributes}
        style={{
          background: '#0d6efd',
          color: '#fff',
          borderRadius: 12,
          padding: "6px 12px",
          cursor: 'grab',

          opacity: isDragging ? 0.4 : 1,

          transform: transform
            ? `translate3d(${transform.x}px, ${transform.y}px, 0)`
            : undefined,

          transition: '.15s',
          boxShadow: '0 5px 18px rgba(0,0,0,.15)',
        }}
      >
        <div
          style={{
            fontWeight: 600,
            marginBottom: 2,
          }}
        >
          Delivery #{pickup.id}
        </div>

        <div>{pickup.driver?.name || 'Unassigned'}</div>

        <div
          style={{
            fontSize: 13,
            opacity: 0.9,
            marginTop: 2,
          }}
        >
          {pickup.user?.full_name}
        </div>
      </div>
    </Link>
  );
};

export default Card;
